export default "7fff87853c793869.svg"